export default {
	user: 'user',
	intervention: 'intervention',
	userCreate: 'Add a user',
	userUpdate: 'Edit a user',
	userDelete: 'Delete a user',
	interventionCreate: 'Add an intervention',
}
